module.exports = __webpack_public_path__ + "img/sticker.f060d9b4.png";